import React from 'react';
import { Flex } from 'rebass';
import Icon from '../Icon/Icon';
import { FragmentOf } from 'gql.tada';
import { STRIPE_PAYMENT_METHOD } from 'modes/company/pages/profile/CompanyProfile.query';

type Props = {
  method?: FragmentOf<typeof STRIPE_PAYMENT_METHOD>;
};

const formatAccountType = (type?: string) => {
  if (!type) return '';
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
};

export default function SavedPaymentMethodBank({ method }: Props) {
  if (!method) {
    return (
      <Flex p={4} fontSize="14px" color="#555">
        No bank account on file.
      </Flex>
    );
  }

  return (
    <Flex
      sx={{
        alignItems: 'center',
        lineHeight: '14px',
        justifyContent: 'space-between',
        padding: 4,
        borderRadius: 'default',
        border: '1px solid #e5e5e5',
        boxShadow: 'paymentMethod',
        fontSize: '14px',
        color: '#555',
      }}
    >
      <Flex alignItems="center" sx={{ gap: 3 }}>
        <Flex sx={{ minWidth: 46, justifyContent: 'center' }}>
          <Icon icon="bank" size="42" />
        </Flex>
        <Flex flexDirection="column">
          <div>{method.bankName || 'Bank Account'}</div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {method.accountHolderType
              ? `${formatAccountType(method.accountHolderType)} • `
              : ''}
            {method.accountType
              ? `${formatAccountType(method.accountType)} • `
              : ''}
            ****{method.last4}
          </div>
        </Flex>
      </Flex>
    </Flex>
  );
}
